import ArticleCallToAction from '@/cmsComponents/ArticleCallToAction';
import { MarkdownContent } from '@/cmsComponents/MarkdownContent';
import { IArticleCta } from '@/types/cms';
import React, { useState } from 'react';

type ArticleContentWithCtaProps = {
  content: string;
  articleCta?: IArticleCta | null;
};

// The CMS article_cta relation can't be left blank, so editors select a sentinel
// CTA entry named "None" to opt an article out of showing a CTA.
const NONE_ARTICLE_CTA_NAME = 'none';

const ArticleContentWithCta = ({ content, articleCta }: ArticleContentWithCtaProps) => {
  // splitting on newline character had a couple of "" entries in the splitContent array so filter them out too
  const splitContent = content.split('\n').filter(paragraph => paragraph.trim());

  // Get the exact mid point as the inital value
  const [ctaIndex, setCtaIndex] = useState<number>(
    Math.max(Math.floor(splitContent.length / 2), 1),
  );
  const resolvedArticleCta =
    articleCta && articleCta.name?.trim().toLowerCase() !== NONE_ARTICLE_CTA_NAME
      ? articleCta
      : undefined;
  const hasArticleCta = !!resolvedArticleCta;

  const isCtaInList = (firstChar: string) => {
    // If the first character is a number or a -, assume it is a list and move the CTA down one
    if (!!Number(firstChar) || firstChar === '-') {
      setCtaIndex(prevIndex => prevIndex + 1);
    }
  };

  const blocks: React.ReactNode[] = [];

  for (let i = 0; i < splitContent.length; i++) {
    if (i === ctaIndex && hasArticleCta) {
      isCtaInList(splitContent[i].charAt(0));
      blocks.push(<ArticleCallToAction {...resolvedArticleCta} />);
    }
    blocks.push(<MarkdownContent source={splitContent[i]} />);
  }
  if (blocks.length === 1 && hasArticleCta) {
    blocks.push(<ArticleCallToAction {...resolvedArticleCta} />);
  }

  return <>{blocks}</>;
};

export default ArticleContentWithCta;
